import { useState } from "react";
import { toast } from "sonner";
import { Share2, Check, Copy, MessageCircle } from "lucide-react";

export default function ShareButton({ url, title = "See how we connect", text = "", variant = "light" }) {
  const [copied, setCopied] = useState(false);
  const fullUrl = url.startsWith("http") ? url : `${window.location.origin}${url}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      toast.success("Link copied — share it proudly!");
      setTimeout(() => setCopied(false), 2200);
    } catch {
      toast.error("Couldn't copy the link");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, text, url: fullUrl }); } catch { /* cancelled */ }
    } else {
      copy();
    }
  };

  const whatsapp = `https://wa.me/?text=${encodeURIComponent(`${text} ${fullUrl}`)}`;
  const dark = variant === "dark";

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-controls">
      <button
        onClick={nativeShare} data-testid="share-button"
        className={`inline-flex items-center gap-2 font-semibold py-3 px-6 rounded-xl transition-colors ${
          dark ? "bg-white/15 hover:bg-white/25 text-white" : "bg-[#F4EAE1] hover:bg-[#eeddd0] text-[#6B21A8]"}`}
      >
        <Share2 size={18} /> Share
      </button>
      <button
        onClick={copy} data-testid="share-copy"
        className={`inline-flex items-center gap-2 font-semibold py-3 px-5 rounded-xl transition-colors ${
          dark ? "bg-white/10 hover:bg-white/20 text-white" : "bg-[#F3EDE4] hover:bg-[#eee5d8] text-[#6E655F]"}`}
      >
        {copied ? <Check size={18} /> : <Copy size={18} />} {copied ? "Copied" : "Copy link"}
      </button>
      <a
        href={whatsapp} target="_blank" rel="noreferrer" data-testid="share-whatsapp"
        className={`inline-flex items-center gap-2 font-semibold py-3 px-5 rounded-xl transition-colors ${
          dark ? "bg-white/10 hover:bg-white/20 text-white" : "bg-[#F2E9FA] hover:bg-[#E4D6F5] text-[#3F3A44]"}`}
      >
        <MessageCircle size={18} /> WhatsApp
      </a>
    </div>
  );
}
